/* tslint:disable:indent */
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, ActivationEnd, Router } from '@angular/router';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { first, map, mergeMap } from 'rxjs/operators';
import { AuthSessionFactoryService } from '../authentication/services/auth-session-factory.service';
import { AuthSessionServiceDelegate } from '../authentication/services/delegate.auth.session.service';
import { Profile } from '../modules/administration/models/profile';
import { Profiles } from '../modules/administration/models/profiles';
import { SessionConnectorService } from '../modules/administration/services/session-connector.service';
import { SpinnerComponent } from '../modules/shared/components/spinner/spinner.component';
import { AccessDeniedService } from '../modules/shared/services/access-denied.service';
import { LogService } from '../modules/shared/services/log.service';
import { AutoCompleteService } from '../modules/shared/services/auto-complete.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public mapLang = new Map<any, any>();
  public title = 'Avis de publicité';
  public error = false;
  public currentLanguage;
  public currentLanguageCode;
  public SPINNER_COMPONENT = SpinnerComponent;
  // Requêtes sans spinner plein écran : la modale du message de refus affiche son propre indicateur
  public listeUrlToIgnore = ['avisPubMsg'];
  private LOG: LogService = new LogService(AppComponent);

  constructor(
    private router: Router,
    private authSessionService: AuthSessionServiceDelegate,
    private sessionConnector: SessionConnectorService,
    private accessDeniedService: AccessDeniedService,
    private authSessionFactory: AuthSessionFactoryService,
    private spinner: SpinnerVisibilityService,
    private autoCompleteService: AutoCompleteService
  ) {
  }

  public ngOnInit() {
    registerLocaleData(localeFr, 'fr');
    this.mapLang = new Map([
      ['fr', 'language.french'],
      ['en', 'language.english'],
    ]);

    this.router.events // We need to get the full path of the route
      .pipe(
        first(event => event instanceof ActivationEnd),
        map((event: ActivationEnd) => event.snapshot)
      )
      .subscribe(route => this.configureAuth(route));

    if (!environment.local) {
      (window as any).siteId = environment.siteId;
      const script = document.createElement('script');
      script.src = 'assets/matomo/matomo.js';
      document.body.appendChild(script);
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
  }

  public closeMenu() {
    if (document.getElementById('sidenav-mobile') != null) {
      document.getElementById('sidenav-mobile').style.width = '0';
    }
    if (document.getElementById('opacity').style.display != null) {
      document.getElementById('opacity').style.display = 'none';
    }
  }

  private configureAuth(route: ActivatedRouteSnapshot) {
    this.spinner.show();

    this.authSessionService.configureWithDelegate(this.authSessionFactory.createSession(route));

    this.authSessionService.configure()
      .pipe(
        mergeMap(() => this.authSessionService.getProfiles()),
        map((profiles: Profiles) => profiles.getDefaultProfile())
      )
      .subscribe({
        next: (defaultProfile: Profile) => {
          this.sessionConnector.connect(defaultProfile);
          this.spinner.hide();
          //Chargement des référentiels
          this.autoCompleteService.loadReferences();
        },
        error: error => {
          this.LOG.error('An error occured when retrieving the default profile:' + error?.message);
          this.accessDeniedService.unauthorized();
          this.spinner.hide();
        }
      });
  }
}

